import React from 'react';
import NavLink from "../Navigation/NavLink";
import {ChevronDown, ChevronUp} from "react-feather";

const NavDropDown = ({title, menuItems}) => {

    const [isOpen, setIsOpen] = React.useState(false);

    return <li className="sl-font sl-font-medium sl-text-md sl-py-8 sl-px-12 sl-relative">
        <div
            className="sl-inline-flex sl-btn sl-btn-link-gray sl-text-md sl-relative sl-items-center sl-gap-1 sl-items-center"
            onClick={() => setIsOpen(!isOpen)}>
            {title}

            {!isOpen ? <ChevronDown size={20}/> : <ChevronUp size={20}/>}

        </div>
        {isOpen && <ul id="projects-dropdown-menu"
                       className="sl-z-10 sl-top-12 sl-w-max-content sl-absolute sl-dropdown-more-menu
                                                        sl-flex sl-flex-col sl-top-full sl-left-0 sl-bg-white sl-border
                                                        sl-border-gray-100 sl-shadow-lg sl-w-160 sl-rounded-lg">

            {menuItems.map((item, index) => (
                <NavLink key={index} href={item.href} text={item.text}
                         listClass={`sl-font sl-font-medium sl-text-sm sl-py-8 sl-px-12 ${item.additionalListClasses} sl-min-w-40`}
                         linkClass={`sl-btn sl-btn-link-gray sl-text-gray-base sl-no-underline`}
                />
            ))}
        </ul>}
    </li>
}

export default NavDropDown;